import commonSetting from '@intelligence/components/DownloadCommon/DownloadPage/configs/commonSetting';
import { metricTitleMap } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import { getMobileDetailDownloadTitle } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseSetting';
import {
  pipe,
  granularityObject,
  getFileName,
} from '@intelligence/components/DownloadCommon/DownloadPage/utils';
import {
  setItem,
  setMetricTitle,
  setPercentForPCConsole,
  setTitleByDateMethod,
  setTitleByMainGenreShow,
  setTitleByRegionMethod,
  setTitleByFixed,
} from '@intelligence/components/DownloadCommon/DownloadPage/common/titleSettingAtom';
import {
  downloadApiListConst,
  sheetNameList,
  pageSize,
} from '@intelligence/components/DownloadCommon/DownloadPage/const/genreProfileTopChartsConst';

// Metrics集合key对应标题
const newMetricMap = {
  ...metricTitleMap,
};

// 根据用户勾选下载页签，获取对应页签配置
const getPageConfig = (params: any) => {
  const downloadMetrics: any = params?.genre_types || [];
  const dataSource = params?.filter?.sourceMetrics || '';
  let configList: any = [];
  configList = sheetNameList?.filter((item: any) => downloadMetrics?.includes(item.typeValue));
  configList = configList?.map((item: any) => {
    const filterSource = item?.pipeMetricList?.filter(
      (metricItem: any) => metricItem?.source === dataSource,
    );
    return {
      ...item,
      pipeMetricList: filterSource,
    };
  });
  return configList;
};

// 根据用户勾选下载页签，获取对应页签配置
const getDataKey = (params: any) => {
  const configListTemp = getPageConfig(params);
  return configListTemp?.map((item: any) => item.typeName);
};

// 根据用户勾选下载页签，获取需要调用的接口
const getDownloadApiListObjByType = (params: any) => {
  const {
    region_method = '',
    downlaod_date_method,
    requestParams = {},
    genre_source,
    entity_type,
    granularity,
    start_date,
    end_date,
    select_top,
    tableData = [],
  } = params;
  let { regions } = params;

  // console.debug('paramsparamsefwef', params);

  const groupByList: any = [];
  const isByTime = downlaod_date_method !== 'aggregated';
  if (downlaod_date_method !== 'aggregated') {
    groupByList.push('date');
  }
  if (region_method === 'market') {
    groupByList.push('market');
  }
  if (region_method === 'region') {
    groupByList.push('region');
  }
  let orderByList: any = ['revenue desc'];
  if (entity_type === 'total') {
    orderByList = ['total_revenue desc'];
  }
  if (downlaod_date_method !== 'aggregated') {
    orderByList = ['date desc', ...orderByList];
  }

  if (region_method !== 'aggregated' && regions.length === 1 && regions[0] === 'global') {
    regions = [];
  }

  delete requestParams.top_game_count;

  const sourceMetricsTemp =
    entity_type === 'total'
      ? {
        sensortower: [],
        npd: [],
        mscience: [],
      }
      : requestParams.source_metrics;

  const common: any = {
    group_by: groupByList,
    genre_source,
    regions,
    entity_type,
    source_metrics: sourceMetricsTemp,
    order_by: orderByList,
    granularity,
    start_date,
    end_date,
    page: 1,
    page_size: select_top || pageSize,
  };

  if (genre_source === 'sensortower') {
    common.genre = [];
    common.iegg_genre_req = [];
    common.sensortower_genre = requestParams.sensortower_genre || [];
  }

  // 如果是 byTime 且手动选择了下载个数，则根据页面返回的 top N 数据组装 genre 过滤条件
  if (
    isByTime &&
    select_top < 99999 &&
    params.genre_tab === 'mainsub' &&
    params.genre_types?.length === 1 &&
    params.genre_types?.includes('mainsub')
  ) {
    const topGenreList = Array.isArray(tableData) ? tableData.slice(0, select_top) : [];

    if (genre_source === 'iegg') {
      const ieggGenreMap = topGenreList.reduce((result: Record<string, Set<string>>, item: any) => {
        const mainGenre = item?.genre;
        const subGenre = item?.sub_genre;

        if (!mainGenre) {
          return result;
        }

        if (!result[mainGenre]) {
          result[mainGenre] = new Set();
        }

        if (subGenre) {
          result[mainGenre].add(subGenre);
        }

        return result;
      }, {});

      common.iegg_genre_req = Object.keys(ieggGenreMap).map((mainGenre) => ({
        relation: 'or',
        value: mainGenre,
        children: Array.from(ieggGenreMap[mainGenre]).map((subGenre) => ({
          value: subGenre,
        })),
      }));
    }

    if (genre_source === 'appannie') {
      const genreMap = new Map<string, { main: string; sub: string }>();

      topGenreList.forEach((item: any) => {
        const mainGenre = item?.genre;
        const subGenre = item?.sub_genre;

        if (!mainGenre) {
          return;
        }

        const key = `${mainGenre}__${subGenre || ''}`;

        if (!genreMap.has(key)) {
          genreMap.set(key, {
            main: mainGenre,
            sub: subGenre || [],
          });
        }
      });

      common.genre = Array.from(genreMap.values());
    }

    if (genre_source === 'sensortower') {
      const genreMap = new Map<string, { main: string; sub: string }>();

      topGenreList.forEach((item: any) => {
        const mainGenre = item?.genre;
        const subGenre = item?.sub_genre;

        if (!mainGenre) {
          return;
        }

        const key = `${mainGenre}__${subGenre || ''}`;
        if (!genreMap.has(key)) {
          genreMap.set(key, {
            main: mainGenre,
            sub: subGenre || [],
          });
        }
      });

      common.sensortower_genre = Array.from(genreMap.values());
    }

    common.page_size = 100000;
  }

  const downloadApiListObj = {
    ...downloadApiListConst,
    main: {
      ...downloadApiListConst.main,
      apiParams: {
        ...downloadApiListConst.main?.apiParams,
        ...requestParams,
        genre_tab: 'main',
        ...common,
      },
    },
    sub: {
      ...downloadApiListConst.sub,
      apiParams: {
        ...downloadApiListConst.sub?.apiParams,
        ...requestParams,
        genre_tab: 'sub',
        ...common,
      },
    },
    mainsub: {
      ...downloadApiListConst.mainsub,
      apiParams: {
        ...downloadApiListConst.mainsub?.apiParams,
        ...requestParams,
        genre_tab: 'mainsub',
        ...common,
      },
    },
  };
  return downloadApiListObj;
};

// 设置下载数据指标表头与对应数据配置
const mergeDataCommon = (
  paramsValue: Record<string, any> = {},
  sheetObj: any = {},
  sourceDownloadSegment = {},
) => {
  let result: any[] = [];
  const segments: any = sourceDownloadSegment || {};
  // eslint-disable-next-line no-prototype-builtins
  if (sheetObj?.hasOwnProperty('metricKey')) {
    if (sheetObj?.metricKey === '') {
      // 如果sheetObj?.metricKey 为空，即全部渲染
      result = sheetObj?.pipeMetricList?.map((metricObj: any) => {
        return { Metric: metricObj.title, Source: '' };
      });
    } else if (sheetObj?.metricKey !== '' && Array.isArray(paramsValue[sheetObj?.metricKey])) {
      // 如果指标直接为下载弹窗勾选的，指标字符串数组，且给了指标字段key
      const metricList = paramsValue[sheetObj?.metricKey] || [];
      result = metricList?.map((metric: any) => {
        return { Metric: metric, Source: '' };
      });
    }
  }

  // 旧有逻辑
  const metrics = paramsValue.source_metrics || {};
  // 遍历 source_metric 中的每个键
  Object.keys(metrics)?.forEach((key) => {
    // 获取当前键对应的 metrics 数组
    const currentMetrics = metrics[key] || [];
    // 获取当前键对应的 segments 数组
    const currentSegments = segments[key] || [];

    // 遍历 metrics 数组
    currentMetrics?.forEach((metric: any) => {
      // 遍历 segments 数组
      if (paramsValue.segment_method === 'aggregated' || !paramsValue.segment_method) {
        result.push({ Metric: metric, Source: '' });
      } else {
        if (currentSegments?.length) {
          currentSegments?.forEach((segment: any) => {
            // 将结果添加到结果数组中
            result.push({ Metric: metric, Segment: segment, Source: '' });
          });
        } else {
          result.push({ Metric: metric, Segment: '', Source: '' });
        }
      }
    });
  });

  return result;
};

// 根据条件动态生成处理链
const createProcessor = (paramsValue: any, pipeFrontList: any[]) => {
  const funcsList: any[] = [];
  pipeFrontList?.forEach((item: any) => {
    // 如果是固定字段
    if (item.isFixed && item.isFixed === true) {
      funcsList.push(setTitleByFixed(item));
    } else {
      switch (item.title) {
        case 'Date':
          funcsList.push(setTitleByDateMethod(paramsValue.downlaod_date_method));
          break;
        case 'Market':
          funcsList.push(setTitleByRegionMethod(paramsValue.region_method, true));
          break;
        case 'Genre':
          funcsList.push(setTitleByMainGenreShow(paramsValue.genre_method));
          break;
      }
    }
  });
  return pipe(...funcsList);
};

// 获取下载表头
const getSheetNamesList = (params: Record<string, any> = {}, sheetObj: any = {}) => {
  // const paramsValue = {
  //   ...params,
  //   download_metrics: getDownloadParamsMetrics(params?.download_metrics),
  // } as any;

  // 获取下载表格，Basic Info 表头配置
  const pipeFront = createProcessor(params, sheetObj?.pipeFrontList);

  // 获取下载表格，指标表头配置
  const metricList = mergeDataCommon(params, sheetObj);

  const pipeInLoop = pipe(
    setItem,
    setMetricTitle(newMetricMap, params.date_type, 'isObject'),
    setPercentForPCConsole(params.ratio_show),
  );

  // 下载表格表头标题排序
  const excelTitleList = getMobileDetailDownloadTitle(pipeFront, metricList, pipeInLoop);
  return {
    [sheetObj.typeName]: excelTitleList,
  };
};

// 获取下载表头
const getSheetNames = (params: Record<string, any> = {}) => {
  const configList = getPageConfig(params);

  let sheetNameValueList: any = [];
  let sheetNamesValueTemp: any = {};
  sheetNameValueList = configList?.map((item: any) => item.typeName);

  configList?.forEach((item: any) => {
    sheetNamesValueTemp = {
      ...sheetNamesValueTemp,
      ...getSheetNamesList(params, item),
    };
  });

  return {
    sheetName: sheetNameValueList,
    ...sheetNamesValueTemp,
  };
};

// 下载个性化接口参数与表格配置
export default (params: Record<string, any>) => ({
  ...commonSetting,
  isUsingNewMethod: false,
  $$fileName: getFileName(params),
  downloadFetchApi: '',
  dataKey: getDataKey(params),
  regionOptions: params?.regionOptions,
  byDate: params?.downlaod_date_method !== 'aggregated',
  granularity: granularityObject[params?.granularity],
  downloadApiListObj: getDownloadApiListObjByType(params),
  fetchOnlyOnce: false,
  isNoHeadTitle: true,
  ...getSheetNames(params),
  // ...getSheetNamesList(params),
});
